import React from 'react'
import { useLocation } from '@tanstack/react-router'
import { cn } from '@/libs/utils'

interface MainProps extends React.HTMLAttributes<HTMLElement> {
  fixed?: boolean
  ref?: React.Ref<HTMLElement>
}

export const Main = ({ fixed, ...props }: MainProps) => {
  const href = useLocation({ select: (location) => location.href })
  const isAdmin = href.includes('/admin')
  return (
    <main
      className={cn(
        isAdmin ? '' : 'mt-[64px]',
        'px-4 py-6',
        fixed && 'fixed-main flex flex-grow flex-col overflow-hidden'
      )}
      {...props}
    />
  )
}

Main.displayName = 'Main'
